<script lang="ts">
    import CasinoHub from '$lib/layouts/fabric/Hubs/CasinoHub.svelte';
    import PageBuilder from '$src/lib/components/PageBuilder/PageBuilder.svelte';
    import { getContext } from 'svelte';

    let { data, children } = $props();
    const { casinoHubTranslations, showFabricLobbies = false, isLoggedIn } = data;

    const isInGamePage = getContext<{ current: boolean }>('isInGamePage');
    let vertical = getContext<{ current: 'casino' | 'sports' }>('vertical');

    vertical.current = 'casino';
    const flags = { showFabricLobbies };
</script>

{#if isInGamePage.current && isLoggedIn}
    {@render children()}
{:else if data.casinoHubTranslations}
    <CasinoHub translations={casinoHubTranslations} {flags} {isLoggedIn}>
        <div class="bg-white">
            {@render children()}
        </div>
    </CasinoHub>
{/if}
<PageBuilder {...data.hubCommonBlocks} debug={data.debugMode} />
